// store/feature/test-procedure/testProcedureSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import { fetchTestProcedures, addTestProcedure, deleteTestProcedure } from './testProcedureThunk';

interface TestProcedure {
  id: number;
  case_id: number;
  test_name: string;
  reported_name: string;
  result: string;
  result_unit: string;
  units: string;
  normal_low: number;
  normal_high: number;
  reference_range: string;
  test_date: string;
  interpretation: string;
  details: string;
}

interface TestProcedureState {
  data: TestProcedure[];
  loading: boolean;
  error: string | null;
  adding: boolean;
  addError: string | null;
}

const initialState: TestProcedureState = {
  data: [],
  loading: false,
  error: null,
  adding: false,
  addError: null,
};

const testProcedureSlice = createSlice({
  name: 'testProcedures',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchTestProcedures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestProcedures.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTestProcedures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Add
      .addCase(addTestProcedure.pending, (state) => {
        state.adding = true;
        state.addError = null;
      })
      .addCase(addTestProcedure.fulfilled, (state, action) => {
        state.adding = false;
      })
      .addCase(addTestProcedure.rejected, (state, action) => {
        state.adding = false;
        state.addError = action.payload as string;
      })
      // Delete
      .addCase(deleteTestProcedure.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTestProcedure.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(item => item.id !== action.payload);
      })
      .addCase(deleteTestProcedure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default testProcedureSlice.reducer;